// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2R2Ly","productName":"Table_productName__1mZou"};